import { render, staticRenderFns } from "./VerAsignacionItems.vue?vue&type=template&id=fb72341c&scoped=true&"
import script from "./VerAsignacionItems.vue?vue&type=script&lang=js&"
export * from "./VerAsignacionItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb72341c",
  null
  
)

export default component.exports